import { createAction, props } from '@ngrx/store';
import { ITenantStatsCounts } from '../../dashboard/interfaces/dashboard.interface';

export const setTenantStatsCount = createAction(
    '[Dashboard] Set Tenant Stats Count',
    props<{ counts: ITenantStatsCounts }>(),
);
